import { Children, cloneElement, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Wrapper,
  ElementAndLabelWrapper,
  LabelWrapper,
  Label,
  Hint,
  Required,
} from './index.styles';

export default function SimpleField({
  children,
  className,
  disabled,
  frame,
  hideRequired,
  hint,
  id,
  label,
  required,
  size,
}) {
  const [invalid, setInvalid] = useState(false);

  const child = Children.only(children);

  return (
    <Wrapper className={className} frame={frame}>
      <ElementAndLabelWrapper size={size}>
        {cloneElement(child, {
          onInvalid: (event) => {
            if (child.props.onInvalid) {
              child.props.onInvalid(event);
            }
            setInvalid(true);
          },
          onInput: (event) => {
            if (child.props.onInput) {
              child.props.onInput(event);
            }
            setInvalid(false);
          },
        })}
        <LabelWrapper>
          <Label disabled={disabled} htmlFor={id} invalid={invalid} size={size}>
            {label}
          </Label>
          {required && !hideRequired ? <Required>Required</Required> : null}
        </LabelWrapper>
      </ElementAndLabelWrapper>
      {hint ? <Hint>{hint}</Hint> : null}
    </Wrapper>
  );
}

SimpleField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  frame: PropTypes.bool,
  hideRequired: PropTypes.bool,
  hint: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.node,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['regular', 'small']),
};
